import Packery from 'packery';

/**
 * <imos-dashboard> lays its child content elements out in a 2-equal-column
 * Packery grid (single column below the md breakpoint). Layout only – no
 * dragging or editing.
 */
export class ImosDashboard extends HTMLElement {
  private packery: Packery | null = null;
  private resizeObserver: ResizeObserver | null = null;
  private relayout = (): void => this.packery?.layout();

  connectedCallback(): void {
    const items = this.querySelectorAll('[id^="c"]');
    if (items.length === 0) {
      return;
    }

    // Sizing helpers read by Packery (kept out of the item selector).
    const sizer = document.createElement('div');
    sizer.className = 'dashboard__sizer';
    const gutterSizer = document.createElement('div');
    gutterSizer.className = 'dashboard__gutter-sizer';
    this.prepend(gutterSizer);
    this.prepend(sizer);

    this.packery = new Packery(this, {
      itemSelector: '[id^="c"]',
      columnWidth: '.dashboard__sizer',
      gutter: '.dashboard__gutter-sizer',
    });

    // Packery's constructor lays out synchronously – reveal now that items are
    // positioned to avoid the flash of the pre-JS stacked layout.
    this.classList.add('is-ready');

    window.addEventListener('resize', this.relayout);
    window.addEventListener('load', this.relayout);

    // Relayout whenever any grid item changes size (e.g. a child component
    // expands/collapses). Generic – no knowledge of specific children.
    this.resizeObserver = new ResizeObserver(this.relayout);
    for (const item of items) {
      this.resizeObserver.observe(item);
    }
  }

  disconnectedCallback(): void {
    window.removeEventListener('resize', this.relayout);
    window.removeEventListener('load', this.relayout);
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;
    this.packery?.destroy();
    this.packery = null;
  }
}

customElements.define('imos-dashboard', ImosDashboard);
